import {
  GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES,
  GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_SUCCESS,
  GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_FAIL,
  GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_RESET,
} from '../actions/getVoiceAssistanceResponseMessagesAction';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
};

const getVoiceAssistanceResponseMessagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES:
      return {
        ...state,
        apiState: 'loading',
      };
    case GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_SUCCESS:
      return {
        ...state,
        apiState: 'success',
        data: action.response.data,
        message: action.response.message || 'success',
      };
    case GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_FAIL:
      return {
        ...state,
        apiState: 'error',
        error: action.response.errors,
        message: action.response.message || 'error',
      };
    case GET_VOICE_ASSISTANCE_RESPONSE_MESSAGES_RESET:
      return initialState;
    default:
      return state;
  }
};

export default getVoiceAssistanceResponseMessagesReducer;
